import dayjs from "dayjs";
import { SubjectSpec } from "./subject";
import { comparePotentiallyNumbered } from "./util";
import { DocumentSnapshot, Timestamp } from "@atgof-firebase/types";

export const SUBJECT_KINDS = ["character", "set"] as const;

export type SheetSubjectKind = (typeof SUBJECT_KINDS)[number];

export type SheetSubject = {
  id: string;
  displayId: string | undefined;
  displayName: string;
  firstDay: dayjs.Dayjs | undefined;
  lastDay: dayjs.Dayjs | undefined;
  isPinned: boolean;
  performerKind: SubjectSpec["performerKind"];
};

export function toSheetSubject(
  item: DocumentSnapshot,
  pinnedSubjects?: string[],
  withoutDisplayId?: boolean,
) {
  const displayName = item.get("displayName");
  const isPinned = pinnedSubjects?.includes(displayName) ? true : false;
  const [firstDay, lastDay] = ["firstDay", "lastDay"].map((attr) => {
    const t: Timestamp | undefined = item.get(attr);
    return t ? dayjs(t.toDate()) : undefined;
  });
  return {
    id: item.id,
    displayName,
    displayId: withoutDisplayId ? undefined : item.get("displayId"),
    performerKind: item.get("kind"),
    firstDay,
    lastDay,
    isPinned,
  };
}

export function searchTokensForSheetSubject({
  displayId,
  displayName,
}: SheetSubject) {
  return [displayId, displayName];
}

export function labelForSheetSubject({ displayId, displayName }: SheetSubject) {
  return (displayId ? `${displayId}. ` : "") + displayName;
}

export function compareSheetSubject(
  a: Partial<SheetSubject>,
  b: Partial<SheetSubject>,
) {
  const res = comparePotentiallyNumbered(a.displayId, b.displayId);
  return res ? res : comparePotentiallyNumbered(a.displayName, b.displayName);
}
